import React, { useState, useEffect } from "react";
import { Button, IconButton } from "@mui/material";
import { IoIosCloseCircleOutline } from "react-icons/io";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

const EditingUser = ({ user, _callback, modal, setModal }) => {
  const [selectedKeys, setSelectedkeys] = useState([]);
  const [allkeys] = useState(["ROLE_USER", "ROLE_ADMIN", "ROLE_SUPPER_ADMIN", "ROLE_MODERATOR"]);

  const [balance, setBalance] = useState(0);

  // get data
  useEffect(() => {
    if (user) {
      setSelectedkeys(user.roles);
      setBalance(user.balance);
    }
  }, [user]);

  // set keywords

  const submitHandler = () => {
    _callback(true, { roles: selectedKeys, balance });
  };
  return (
    <div>
      {user ? (
        <Dialog
          open={modal}
          fullWidth
          maxWidth="md"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            className="d-flex justify-content-between align-items-center px-5"
          >
            <p>
              {" "}
              {user.firstName} {user.lastName}
            </p>
            <IconButton onClick={() => setModal(false)}>
              <IoIosCloseCircleOutline />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <div className="w-100 p-3 ">
              <label>Rollar</label>
              <Autocomplete
                value={selectedKeys || []}
                multiple
                autoHighlight
                id="tags-standard"
                filterSelectedOptions
                options={allkeys}
                getOptionLabel={(option) => option}
                // shu bir qator kod filterni hal qildi
                isOptionEqualToValue={(option, value) => option === value}
                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option}>
                      {option}
                    </li>
                  );
                }}
                onChange={(e, target) => setSelectedkeys(target)}
                renderInput={(params) => (
                  <TextField {...params} color="primary" variant="outlined" />
                )}
              />

              <label className="mt-5">Balance (in soums)</label>
              <input
                type="number"
                value={balance}
                onChange={(e) => setBalance(e.target.value)}
              />

              {/* <label className="mt-5">Tariff</label>
              <CustomSelect
                selVal={tariff}
                selHandle={setTariff}
                selItems={allTariffs}
                type={"contained"}
              /> */}
            </div>
          </DialogContent>
          <DialogActions className="px-5 pb-3">
            <Button onClick={submitHandler} variant="contained" color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}{" "}
    </div>
  );
};

export default EditingUser;
